<script setup>
import Timeline from "@/components/Timeline.vue";
import { useHead } from "@vueuse/head";

// Define page-specific metadata
useHead({
  title: "PESONA 2026 - UTDI",
  meta: [
    {
      name: "description",
      content:
        "Jadwal lengkap kegiatan PESONA 2026 - Penyambutan mahasiswa baru Universitas Teknologi Digital Indonesia (UTDI).",
    },
    {
      property: "og:title",
      content: "PESONA 2026 - UTDI | Jadwal Kegiatan",
    },
    {
      property: "og:description",
      content:
        "Jadwal lengkap kegiatan PESONA 2026 - Penyambutan mahasiswa baru Universitas Teknologi Digital Indonesia (UTDI).",
    },
    {
      name: "keywords",
      content:
        "jadwal PESONA UTDI, kegiatan orientasi mahasiswa baru, timeline PESONA 2026, acara UTDI",
    },
  ],
});
</script>

<template>
  <section id="kegiatan" class="py-16 bg-white">
    <div class="container mx-auto px-5 lg:px-6 max-w-[1380px]">
      <h2
        class="text-3xl font-bold text-center text-primary mb-10"
        data-aos="fade-down"
      >
        Informasi Kegiatan
      </h2>
      <div data-aos="fade-up" data-aos-delay="200">
        <Timeline />
      </div>

      <!-- Grid Layout untuk 2 Cards -->
      <div class="mt-12 grid grid-cols-1 md:grid-cols-2 gap-8 max-w-4xl mx-auto">
        <!-- Card 1: Download Buku Panduan -->
        <div
          class="group bg-gradient-to-br from-white to-gray-50 p-8 rounded-xl shadow-lg hover:shadow-2xl transform hover:-translate-y-2 transition-all duration-300 border border-gray-100 text-center"
          data-aos="fade-up"
          data-aos-delay="300"
        >
          <div
            class="bg-gradient-to-br from-blue-100 to-primary/20 w-20 h-20 rounded-full flex items-center justify-center mx-auto mb-6 group-hover:scale-110 transition-transform duration-300"
          >
            <div class="text-4xl">📚</div>
          </div>
          <h3
            class="font-bold text-xl text-primary mb-4 group-hover:text-accent transition-colors duration-300"
          >
            Download Buku Panduan
          </h3>
          <p class="text-gray-600 mb-6 text-sm leading-relaxed">
            Dapatkan panduan lengkap untuk mengikuti kegiatan PESONA UTDI
          </p>
          <a
            href="https://drive.google.com/file/d/1TEgAF0s45-78NvZ9Ml3ONyyFB5AB3vPP/view?usp=drive_link"
            target="_blank"
            class="inline-flex items-center justify-center bg-gradient-to-r from-primary to-accent hover:from-accent hover:to-primary text-white px-6 py-3 rounded-xl font-semibold transition-all duration-300 transform hover:scale-105 shadow-lg hover:shadow-xl"
          >
            <svg
              class="w-5 h-5 mr-2"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M12 10v6m0 0l-3-3m3 3l3-3m2 8H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
              ></path>
            </svg>
            Download PDF
          </a>
        </div>

        <!-- Card 2: Download Virtual Background -->
        <div
          class="group bg-gradient-to-br from-white to-gray-50 p-8 rounded-xl shadow-lg hover:shadow-2xl transform hover:-translate-y-2 transition-all duration-300 border border-gray-100 text-center"
          data-aos="fade-up"
          data-aos-delay="400"
        >
          <div
            class="bg-gradient-to-br from-purple-100 to-accent/20 w-20 h-20 rounded-full flex items-center justify-center mx-auto mb-6 group-hover:scale-110 transition-transform duration-300"
          >
            <div class="text-4xl">🖼️</div>
          </div>
          <h3
            class="font-bold text-xl text-primary mb-4 group-hover:text-accent transition-colors duration-300"
          >
            Virtual Background & Twibbon
          </h3>
          <p class="text-gray-600 mb-6 text-sm leading-relaxed">
            Koleksi background virtual resmi untuk kegiatan online PESONA
          </p>
          <a
            href="https://drive.google.com/drive/folders/1x6InZzHTdpqv55depKloeDHPAccy4e5A?usp=sharing"
            target="_blank"
            class="inline-flex items-center justify-center bg-gradient-to-r from-primary to-accent hover:from-accent hover:to-primary text-white px-6 py-3 rounded-xl font-semibold transition-all duration-300 transform hover:scale-105 shadow-lg hover:shadow-xl"
          >
            <svg
              class="w-5 h-5 mr-2"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z"
              ></path>
            </svg>
            Download Background
          </a>
        </div>
      </div>
    </div>
  </section>
</template>
